import React from "react";
import { useParams } from 'react-router-dom';
import InvoiceForm from "./components/InvoiceForm";
import MyInvoiceTab from "./components/MyInvoiceTab";

const MyInvoicePreview = () => {
	const { invoiceId } = useParams();

	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<InvoiceForm invoiceNum={invoiceId} mode="view"/>
			 	<MyInvoiceTab />
	      </div>
	    </div>
    );
};

export default MyInvoicePreview;
